<button class="jolojo-ui__button {variant}"
  {size}
  {disabled}
  on:click
>
  <slot />
</button>

<script>
  export let variant = 'primary'
  export let size = 'md'
  export let disabled = false
</script>

<style lang="scss">.jolojo-ui__button {
  transition: all 0.2s ease-in-out;
  border-radius: var(--jolojo-ui-sm-border-radius);
  height: fit-content;
  border: none;
  outline-style: none !important;
  cursor: pointer;
  text-wrap: nowrap;
}
.jolojo-ui__button[size=sm] {
  font-size: var(--jolojo-ui-xs-font-size);
  padding: var(--jolojo-ui-xs-padding) var(--jolojo-ui-md-padding);
  border-radius: var(--jolojo-ui-xs-border-radius);
}
.jolojo-ui__button[size=md] {
  font-size: var(--jolojo-ui-sm-font-size);
  padding: var(--jolojo-ui-sm-padding) var(--jolojo-ui-lg-padding);
}
.jolojo-ui__button[size=lg] {
  font-size: var(--jolojo-ui-md-font-size);
  padding: var(--jolojo-ui-md-padding) var(--jolojo-ui-xl-padding);
  border-radius: var(--jolojo-ui-md-border-radius);
}
.jolojo-ui__button.primary {
  background: var(--jolojo-ui-primary-color);
  color: white;
}
.jolojo-ui__button.primary:hover {
  filter: brightness(0.9);
}
.jolojo-ui__button.outline {
  background: transparent;
  color: var(--jolojo-ui-primary-color);
  border: 1px solid var(--jolojo-ui-primary-color);
}
.jolojo-ui__button.outline:hover {
  filter: brightness(0.9);
}
.jolojo-ui__button.secondary {
  background: var(--jolojo-ui-secondary-color);
  color: white;
}
.jolojo-ui__button.secondary:hover {
  filter: brightness(0.9);
}
.jolojo-ui__button.destructive {
  background: var(--jolojo-ui-destructive-color);
  color: white;
}
.jolojo-ui__button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: none;
}
.jolojo-ui__button:active {
  transform: scale(0.95);
}</style>
<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};</script>